import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../context/AuthContext';

const AccountMenu: React.FC = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  if (!user) return null;

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          color: '#fff', background: 'none', border: 'none', cursor: 'pointer',
          fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '4px',
        }}
      >
        {user.name} ▾
      </button>

      {open && (
        <div style={{
          position: 'absolute', right: 0, top: '100%', marginTop: '8px',
          backgroundColor: '#1e293b', border: '1px solid #334155', borderRadius: '6px',
          minWidth: '220px', boxShadow: '0 4px 12px rgba(0,0,0,0.4)', zIndex: 1000,
        }}>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #334155' }}>
            <div style={{ color: '#fff', fontWeight: 600, fontSize: '0.9rem' }}>{user.name}</div>
            <div style={{ color: '#94a3b8', fontSize: '0.8rem' }}>{user.email}</div>
          </div>

          {user.companies.length > 0 && (
            <div style={{ padding: '8px 0', borderBottom: '1px solid #334155' }}>
              {user.companies.map(c => (
                <button
                  key={c.id}
                  onClick={() => { (window as any).__ACTIVE_COMPANY__ = c; setOpen(false); }}
                  style={{
                    display: 'block', width: '100%', textAlign: 'left',
                    padding: '8px 16px', color: '#cbd5e1', background: 'none',
                    border: 'none', cursor: 'pointer', fontSize: '0.85rem',
                  }}
                  onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#334155')}
                  onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  {c.name}
                </button>
              ))}
            </div>
          )}

          <div style={{ padding: '8px 0' }}>
            <a
              href="/settings"
              style={{ display: 'block', padding: '8px 16px', color: '#cbd5e1', textDecoration: 'none', fontSize: '0.85rem' }}
            >
              Settings
            </a>
            <button
              onClick={() => { logout(); setOpen(false); }}
              style={{
                display: 'block', width: '100%', textAlign: 'left',
                padding: '8px 16px', color: '#f87171', background: 'none',
                border: 'none', cursor: 'pointer', fontSize: '0.85rem',
              }}
            >
              Logout
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountMenu;
